exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sottotitolo-pagina-small[data-v-1da48dd3] {\n  text-align: center;\n  font-size: 20px;\n}\n", "", {"version":3,"sources":["/data/pyprojects/elimina_code/src/views/Login.vue"],"names":[],"mappings":";AA2DA;EACI,mBAAkB;EAClB,gBAAe;CAAG","file":"Login.vue?vue&type=style&index=0&id=1da48dd3&lang=sass&scoped=true","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import \"../assets/css/include-media\";\n@import \"../assets/css/partials/variables\";\n\n.sottotitolo-pagina-small {\n    text-align: center;\n    font-size: 20px; }\n"],"sourceRoot":""}]);

// exports
